import { Component, OnInit } from '@angular/core';
import {IDialogComponent} from '../../../../../modules/common/dialog/iDialog.component';
import {DialogWithInput} from '../../../../../modules/common/dialog/dialogWithInput';
import {
  ConfirmationButtonOptionButton,
  ConfirmationButtonOptionModel
} from '../model/confirmationButtonOption.model';

export interface ConfirmationButtonDialogInput {
  options: ConfirmationButtonOptionModel;
}

export interface ConfirmationButtonDialogResult {
  value: string;
}

@Component({
  selector: 'app-confirmation-button-dialog',
  templateUrl: './confirmation-button-dialog.component.html',
  styles: [
  ]
})
export class ConfirmationButtonDialogComponent implements
    IDialogComponent<ConfirmationButtonDialogInput, ConfirmationButtonDialogResult> {

  dialog: DialogWithInput<ConfirmationButtonDialogInput, ConfirmationButtonDialogResult>;

  constructor() { }

  close(confirm: string) {
    this.dialog.close({
      value: confirm === 'cancel' ? undefined : confirm
    });
  }

  get confirmationMessage(): string {
    return this.dialog.input.options?.confirmationText ?
        this.dialog.input.options?.confirmationText :
        ConfirmationButtonOptionModel.DEFAULT_CONFIRMATION_TEXT;
  }

  get buttons(): ConfirmationButtonOptionButton[] {
    if (this.dialog.input.options?.buttons) {
      return this.dialog.input.options?.buttons;
    }
    const buttons: ConfirmationButtonOptionButton[] = [];
    ConfirmationButtonOptionModel.DEFAULT_BUTTONS.forEach(value => buttons.push(value));
    return buttons;
  }



}
